import { render, staticRenderFns } from "./FutureMeResultsNew.vue?vue&type=template&id=6ecafc96&scoped=true&"
import script from "./FutureMeResultsNew.vue?vue&type=script&lang=js&"
export * from "./FutureMeResultsNew.vue?vue&type=script&lang=js&"
import style0 from "./FutureMeResultsNew.vue?vue&type=style&index=0&id=6ecafc96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecafc96",
  null
  
)

export default component.exports